module.exports = {
      id: "cricket-usage",
      viewBox: "0 0 21.217 19.952",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#cricket",
      toString: function () {
        return this.url;
      }
    }